var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTracker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "stats3",
    className: "cls-1",
    d: "M1008,456a12,12,0,1,1,12-12A12,12,0,0,1,1008,456Zm0-22a10,10,0,1,0,10,10A10,10,0,0,0,1008,434Zm4,15a0.991,0.991,0,0,1-.99-1v-4.99a0.99,0.99,0,1,1,1.98,0V448A0.991,0.991,0,0,1,1012,449Zm-4,0a1,1,0,0,1-1-1v-8a1,1,0,0,1,2,0v8A1,1,0,0,1,1008,449Zm-4,0a0.991,0.991,0,0,1-.99-1v-2.989a0.99,0.99,0,1,1,1.98,0V448A0.991,0.991,0,0,1,1004,449Z",
    transform: "translate(-996 -432)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTracker);
export default __webpack_public_path__ + "static/media/Tracker.8e5106b47e1b778a3658a22b39f01faf.svg";
export { ForwardRef as ReactComponent };